<template>
  <div>
    <v-row>
      <v-col cols="12" md="4">
        <v-card
          color="success"
          class="pa-2"
          style="margin:auto !important;"
          max-width="430"
          hover
          dark
          @click="$router.push('/library')"
        >
          <div class>
            <v-icon
              color="white"
              size="46"
              style="float: left;"
              class="ma-2 mr-5"
              >fas fa-book-open</v-icon
            >

            <div>
              <span style="font-size: 20px;">書籍の点訳データを公開中</span>
              <br />
              <span style="font-size: 12px;">ご自由にどうぞ！</span>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="8" style="font-size: 14px;">
        <v-card
          class="mx-auto"
          color="light-green lighten-4"
          style="border-radius: 0;"
        >
          <div class="pa-2">
            お知らせ
            <!-- <v-btn
              text
              small
              style="float: right;margin-top: -3px;"
              @click="$router.push('/news')"
            >一覧へ</v-btn>-->
          </div>
        </v-card>
        <v-card
          v-for="(item, z) in news"
          :key="z"
          class="mx-auto pa-0"
          style="border-radius: 0;"
        >
          <v-expansion-panels multiple :value="openPanels">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span>{{ "【" + item.date + "】 " + item.title }}</span>
              </v-expansion-panel-header>
              <v-expansion-panel-content style="white-space: pre-wrap;">
                {{ item.text }}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" align="center" justify="center">
        <a href="http://sugitoshakyou.blog45.fc2.com/"
          >社会福祉法人杉戸町社会福祉協議会</a
        >
      </v-col>
      <v-col cols="12" sm="6" align="center" justify="center">
        <a href="http://hiramatu-hifuka.com/onyak/onyindx.html"
          >「音訳の部屋」-読み方辞典-</a
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import firestore from "@/js/firebase";
export default {
  name: "Home",
  data: () => ({
    news: [],
    openPanels: [],
    model: null,
    textarea: "",
  }),
  created() {
    this.get();
  },
  methods: {
    get: function() {
      const s = this;
      let res = [];
      firestore
        .collection("news")
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            let data = doc.data();
            data.id = doc.id;
            res.push(data);
          });
          res.sort(function(a, b) {
            if (a.date < b.date) return 1;
            if (a.date > b.date) return -1;
            return 0;
          });
          if (res.length > 3) {
            res = [res[0],res[1],res[2]]
          }
          s.news = res;
        });
    },
  },
};
</script>

<style scoped>
.book_banner {
  height: 200px;
  max-width: 400px;
}
.book_banner >>> div div,
.book_banner >>> div i {
  color: #fff;
  float: left;
}
</style>
